// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"e5d36e75","37":"e99176b4","67":"489536f0","749":"a9175669","777":"858688b8","799":"d2c539c0"}[chunkId] + ".js";
};